<template>
  <div class="margin-subpages">
    <div class="fs-18 fw-700">Click icon for copy image tag to clipboard</div>
    <div class="icons-table mt-24 mb-24">
      <div
        v-for="value in iconList"
        :key="'icon_' + value"
        @click.prevent="copyURL(value)"
        class="icon-body"
      >
        <div class="mr-12">
          <img
            class="icon-image"
            :src="$utils('icons', value)"
            :title="value"
            :alt="value"
          />
        </div>
        <div class="fc-000000 opa-07 fs-10 mt-4 ellipsis" :title="value">
          {{ value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "icons",
  data() {
    return {
      iconList: [
        "add_purple_10_14dp",
        "add_purple_10_14dp@2x",
        "add_purple_14dp",
        "add_purple_14dp@2x",
        "archive-18px",
        "archive-18px@2x",
        "arrow_down_red_24dp",
        "arrow_down_red_24dp@2x",
        "arrow_down_white_32dp",
        "arrow_down_white_32dp@2x",
        "arrow_up_green_24dp",
        "arrow_up_green_24dp@2x",
        "arrow_up_white_32dp",
        "arrow_up_white_32dp@2x",
        "bar_chart_gray_24dp",
        "bar_chart_gray_24dp@2x",
        "benchmark_Culture - Critical_16x16",
        "benchmark_Culture - Critical_16x16@2x",
        "benchmark_Culture - Excellence_16x16",
        "benchmark_Culture - Excellence_16x16@2x",
        "benchmark_Culture - Fair_16x16",
        "benchmark_Culture - Fair_16x16@2x",
        "benchmark_Resilience - Critical_16x16",
        "benchmark_Resilience - Critical_16x16@2x",
        "benchmark_Resilience - Excellence_16x16",
        "benchmark_Resilience - Excellence_16x16@2x",
        "benchmark_Resilience - Fair_16x16",
        "benchmark_Resilience - Fair_16x16@2x",
        "benchmark_Wellness - Critical_16x16",
        "benchmark_Wellness - Critical_16x16@2x",
        "benchmark_Wellness - Excellence_16x16",
        "benchmark_Wellness - Excellence_16x16@2x",
        "benchmark_Wellness - Fair_16x16",
        "benchmark_Wellness - Fair_16x16@2x",
        "btn_like_off_32px",
        "btn_like_off_32px@2x",
        "btn_like_on_32px",
        "btn_like_on_32px@2x",
        "chart_active_24dp",
        "chart_active_24dp@2x",
        "chart_inactive_24dp",
        "chart_inactive_24dp@2x",
        "chevron_black_left",
        "chevron_black_left@2x",
        "chevron_black_right",
        "chevron_black_right@2x",
        "chevron_white_left_32px",
        "chevron_white_left_32px@2x",
        "chevron_white_right_32px",
        "chevron_white_right_32px@2x",
        "coins-12px",
        "coins-12px@2x",
        "close_fullscreen_24dp",
        "close_fullscreen_24dp@2x",
        "cri_thinking_icon",
        "cri_thinking_icon@2x",
        "daily_streak_icon",
        "daily_streak_icon@2x",
        "date_gray_12",
        "date_gray_12@2x",
        "date_white_24dp",
        "date_white_24dp@2x",
        "delete_black_24dp",
        "delete_black_24dp@2x",
        "Distractors_16",
        "Distractors_16@2x",
        "edit_black_24dp",
        "edit_black_24dp@2x",
        "empathy_icon",
        "empathy_icon@2x",
        "Engagement_Highly_Engaged_32",
        "Engagement_Highly_Engaged_32@2x",
        "Engagement_In-Active_32",
        "Engagement_In-Active_32@2x",
        "Engagement_Moderately_Engaged_32",
        "Engagement_Moderately_Engaged_32@2x",
        "Engagement_Somewhat_Engaged_32",
        "Engagement_Somewhat_Engaged_32@2x",
        "Engagement_Under_Engaged_32",
        "Engagement_Under_Engaged_32@2x",
        "filter-list-24px",
        "filter-list-24px@2x",
        "fix_circle_black_24",
        "fix_circle_black_24@2x",
        "fix_circle_green_24",
        "fix_circle_green_24@2x",
        "fix_circle_red_24",
        "fix_circle_red_24@2x",
        "fix_circle_yellow_24",
        "fix_circle_yellow_24@2x",
        "flag_purple_20dp",
        "flag_purple_20dp@2x",
        "fullscreen_24dp",
        "fullscreen_24dp@2x",
        "groups_black_32dp_30",
        "groups_black_32dp_30@2x",
        "Happiness_Rate_24",
        "Happiness_Rate_24@2x",
        "ic_bolt_black_24dp",
        "ic_bolt_black_24dp@2x",
        "ic_bolt_purple_24dp",
        "ic_bolt_purple_24dp@2x",
        "ic_bolt_white_24dp",
        "ic_bolt_white_24dp@2x",
        "ic_criticalthinking",
        "ic_criticalthinking@2x",
        "ic_empathy",
        "ic_empathy@2x",
        "ic_expand_24dp",
        "ic_expand_24dp@2x",
        "ic_flat_coin",
        "ic_flat_coin@2x",
        "ic_flat_gem",
        "ic_flat_gem@2x",
        "ic_green_yes",
        "ic_green_yes@2x",
        "ic_happily",
        "ic_happily@2x",
        "ic_help_gray_24px",
        "ic_help_gray_24px@2x",
        "ic_help_outline-16px",
        "ic_help_outline-16px@2x",
        "ic_help_white_24px",
        "ic_help_white_24px@2x",
        "ic_initiative",
        "ic_initiative@2x",
        "ic_leadership",
        "ic_leadership@2x",
        "ic_optimism",
        "ic_optimism@2x",
        "ic_org_chart_24px",
        "ic_org_chart_24px@2x",
        "ic_preview",
        "ic_preview@2x",
        "ic_profile_coin",
        "ic_profile_coin@2x",
        "ic_profile_gem",
        "ic_profile_gem@2x",
        "ic_red_no",
        "ic_red_no@2x",
        "ic_reply_arrow_24px",
        "ic_reply_arrow_24px@2x",
        "ic_reply_arrow_small_16px",
        "ic_reply_arrow_small_16px@2x",
        "ic_selfawareness",
        "ic_selfawareness@2x",
        "ic_sparkle_24dp",
        "ic_sparkle_24dp@2x",
        "ic_star_24px",
        "ic_star_24px@2x",
        "ic_star_gray_24px",
        "ic_star_gray_24px@2x",
        "ic_twotone_cal",
        "ic_twotone_cal@2x",
        "ic_twotone_clock",
        "ic_twotone_clock@2x",
        "ic_twotone_location",
        "ic_twotone_location@2x",
        "ic_xls_download",
        "ic_xls_download@2x",
        "initiative_icon",
        "initiative_icon@2x",
        "key_color_32dp",
        "key_color_32dp@2x",
        "key_white_24dp",
        "key_white_24dp@2x",
        "leadership_icon",
        "leadership_icon@2x",
        "lock_white_24dp",
        "lock_white_24dp@2x",
        "Medals_32",
        "Medals_32@2x",
        "no_change_white_32dp",
        "no_change_white_32dp@2x",
        "nudges-32x32",
        "nudges-32x32@2x",
        "nudges-blue-32x32",
        "nudges-blue-32x32@2x",
        "open_in_new_gray_24px",
        "open_in_new_gray_24px@2x",
        "open_in_new_white_24dp",
        "open_in_new_white_24dp@2x",
        "Open-ended_Feedback_24",
        "Open-ended_Feedback_24@2x",
        "Open-ended_fb_rate-32x32",
        "Open-ended_fb_rate-32x32@2x",
        "Open-ended_fb_rate-blue-32x32",
        "Open-ended_fb_rate-blue-32x32@2x",
        "Optimism_icon",
        "Optimism_icon@2x",
        "Outstanding_32",
        "Outstanding_32@2x",
        "Passives_16",
        "Passives_16@2x",
        "Promoters_16",
        "Promoters_16@2x",
        "Reply_quality-32x32",
        "Reply_quality-32x32@2x",
        "Reply_quality-blue-32x32",
        "Reply_quality-blue-32x32@2x",
        "Reply_rate-32x32",
        "Reply_rate-32x32@2x",
        "Reply_rate-blue-32x32",
        "Reply_rate-blue-32x32@2x",
        "Risk_Rate_v1_24",
        "Risk_Rate_v1_24@2x",
        "Risk_Rate_v2_24",
        "Risk_Rate_v2_24@2x",
        "Risk_Rate_v3_24",
        "Risk_Rate_v3_24@2x",
        "same_score_24dp",
        "same_score_24dp@2x",
        "self_awareness_icon",
        "self_awareness_icon@2x",
        "skill_off",
        "skill_off@2x",
        "skill_on",
        "skill_on@2x",
        "sig_bridge",
        "sig_bridge@2x",
        "sig_brokerage",
        "sig_brokerage@2x",
        "sig_cohesion",
        "sig_cohesion@2x",
        "sig_collective",
        "sig_collective@2x",
        "sig_influence",
        "sig_influence@2x",
        "sig_reachability",
        "sig_reachability@2x",
        "sig_communityleader",
        "sig_communityleader@2x",
        "sig_hub",
        "sig_hub@2x",
        "sig_link",
        "sig_link@2x",
        "sig_ripple",
        "sig_ripple@2x",
        "sig_strategist",
        "sig_strategist@2x",
        "sup_feedback_icon",
        "sup_feedback_icon@2x",
        "sup_recog_icon",
        "sup_recog_icon@2x",
        "Super_Star_32",
        "Super_Star_32@2x",
        "Top_performer-32x32",
        "Top_performer-32x32@2x",
        "Top_performer-blue-32x32",
        "Top_performer-blue-32x32@2x",
        "trending_down_white_16dp",
        "trending_down_white_16dp@2x",
        "trending_flat_white_16dp",
        "trending_flat_white_16dp@2x",
        "trending_up_white_16dp",
        "trending_up_white_16dp@2x",
        "User_status_Active_24px",
        "User_status_Active_24px@2x",
        "User_status_Inactive_24px",
        "User_status_Inactive_24px@2x",
        "User_status_Passive_24px",
        "User_status_Passive_24px@2x",
        "visibility_black_24dp",
        "visibility_black_24dp@2x",
        "visibility_off_black_24dp",
        "visibility_off_black_24dp@2x",
        "arrow-10_48x20px",
        "x-16x16px",
        "setting_Icon",
        "Add_white",
        "ic_activelearning",
        "ic_completed",
        "ic_learningtime",
        "Ic_read",
        "ic_upskilled"

      ],
    };
  },
  methods: {
    copyURL(value) {
      // Generate the image tag using a template literal
      const imageTag = `<img :src="$utils('icons', '${value}')" alt="icons_${value}" />`;

      // Access the clipboard API
      const clipboardData = window.clipboardData || navigator.clipboard;

      // Write the image tag to the clipboard in a try-catch block
      try {
        clipboardData.writeText(imageTag);

        // Show a success message
        this.$message({
          message: `Copy image ${value} to clipboard.`,
          type: "success",
        });
      } catch (error) {
        // Handle any errors
        console.error("Error copying image tag to clipboard:", error);

        // Show an error message
        this.$message({
          message: `Failed to copy image ${value} to clipboard.`,
          type: "error",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-image {
  box-shadow: 0px 2px 4px #00000029;
  border-radius: 4px;
  background-color: #e2e2e2;
  transition: 0.2s;
  max-width: 32px;
  max-height: 32px;
  object-fit: cover;
  &:hover {
    margin-bottom: 4px;
    box-shadow: 0px 6px 6px #00000019;
  }
}
.icon-body {
  padding: 4px 4px;
  width: calc(100% - 8px);
  height: 32px;
  display: flex;
  align-items: center;
  transition: 0.3s;
  border-radius: 4px;
  margin: 4px 0;
  cursor: pointer;
  &:hover {
    background: #f5f5f5;
  }
}
.icons-table {
  display: grid;
  grid-template-columns: repeat(4, calc(100% / 4 - (60px / 4)));
  gap: 0 20px;
}
</style>
